MxObjectMapper.$inject = ['mx.internationalization'];
/**
 * @ngdoc service
 * @name mx.shell.ObjectMapper
 * @module mx.shell
 *
 * @description
 * A service provides methods for mapping business items to pandora items. Can be rewritten
 * */
export function MxObjectMapper(i18n) {
	return { mapItem: mapItem };

	/**
	 * @ngdoc method
	 * @name mx.shell.ObjectMapper#mapItem
	 *
	 * @description
	 * Maps business object to {@ref mx.shell.Object object}. Should be implemented<br>
	 * As result - those {@ref mx.shell.Object object} items must contain keys like:
	 * - "_id" <br>
	 * - "_type" <br>
	 * - "_name" <br>
	 * - "_displayName" <br>
	 * - "_state" <br>
	 *<br>
	 * Details in {@ref mx.shell.Object Object description}
	 *
	 * @returns {mx.shell.Object} {@ref mx.shell.Object object}
	 */
	function mapItem(item) {
		item._type = item['Sys-Entity'];
		item._id = item['Sys-ObjectId'] ? item['Sys-ObjectId'].toLowerCase() : item.ID ? item.ID.toLowerCase() : null;
		item._state = item['Sys-EntityState'];
		// item.DisplayString is needed for ObjectPicker and DefaultDQ
		item._displayName = item.DisplayString = item['Sys-DisplayName'] || item.DisplayString || i18n.notAvailable();
		item._name = item._displayName;
		if (item['Sys-Archived']) {
			item._archived = true;
		}
		// item._itemType = 'CI';

		return item;
	}
}
